import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { ownerNav } from '@/lib/navConfig';
import CustomersManager from '@/components/customers/CustomersManager';

export default function OwnerCustomers() {
  return (
    <AppShell nav={ownerNav} title="Daftar Customer" showBell>
      <CustomersManager />
    </AppShell>
  );
}
